// extracted by mini-css-extract-plugin
module.exports = {"productImage":"Collections_productImage__1j2GE"};